const AppConfig = {
  appLogo: require("Assets/img/logo/appLogo.svg"), // App Logo
  appLogoText: require("Assets/img/logo/appLogoText.svg"),
  
  rtlLayout: true,
  locale: {
    languageId: "persian",
    locale: "fa",
    name: "فارسی",
    icon: "fa",
  },

  // rtlLayout: false,
  // locale: {
  //   languageId: 'english',
  //   locale: 'en',
  //   name: 'English',
  //   icon: 'en',
  // },

  defaultProvince: 8, //tehran
  defaultCity: 329,

  themeColors: {
    primary: "#3b4453",
    primaryDark: "#2e3440",
    secondaryLight: "#c6e9fa",
    secondary: "#3a99d9",
    secondaryDark: "#2e81b7",
    success: "#1abc9c",
    successDarken: "#16a085",
    danger: "#ed5f55",
    dangerDarken: "#c0392b",
    warning: "#ffcd02",
    warningDarken: "#ffa800",
    info: "#3498db",
    infoDarken: "#2980b9",
    darker: "#2e3440",
    dark: "#3b4453",
    default: "#f0f0f1",
    greyLighten: "#c7cbd4",
    grey: "#a5adb8",
    light: "#ecf0f1",
    white: "#ffffff",
    black: "rgba(23, 23, 23, 1)",
    purple: "#cb93ec",
    yellow: "#ffcd02",
    darkYellow: "#ffa800",
    green: "#42cb6f",
    darkGreen: "#3bb85d",
    red: "#ed5f55",
    darkRed: "#da4d43",
    borderColor: "#a5adb8",
    gradientPrimary: "linear-gradient(90deg, #2e3440 30%, #3b4453 90%)",
    txtPrimary: "#6c737e",
  },

  tarahiColors: {
    primary: "#3a99d9",
  },
  drawerWidth: 62,
  headerHeight: 42,
};

export default AppConfig;
